import { render, staticRenderFns } from "./SectionSummary.vue?vue&type=template&id=58461a93&scoped=true&"
import script from "./SectionSummary.vue?vue&type=script&lang=ts&"
export * from "./SectionSummary.vue?vue&type=script&lang=ts&"
import style0 from "./SectionSummary.vue?vue&type=style&index=0&id=58461a93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58461a93",
  null
  
)

export default component.exports